import createClient from '../../apolloClient';
import MUTATION_FORGOT_PASSWORD from '../../mutation/forgotPassword';

const handleForgotPassword = async (variables) => {
  const client = createClient();
  const result = await client.mutate({
    mutation: MUTATION_FORGOT_PASSWORD,
    variables,
  });
  const { forgotPassword } = result?.data || {};
  return forgotPassword;
};

export default handleForgotPassword;
